/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class Loading extends React.Component {
    render() {
        return (
            <div className="loading">
                <h3>
                    <i className="fa fa-spinner fa-spin"></i>
                    <br/> {this.props.label}
                </h3>
            </div>
        );
    }
};

Loading.displayName = "Loading";

Loading.propTyps = {
    label: PropTypes.string
};

Loading.defaultProps = {
    label: 'Loading'
};

export default Loading;
